export interface ISubscription {
  _id: string
  subscriptionPlan: string
  status: string
  currentPeriodEnd: Date
  checkoutUrl: string
  createdAt: string
  updatedAt: string
}

export interface ISubscriptionPlan {
  _id: string
  type: SubscriptionPlanType
  name: string
  currency: string
  monthlyPrice: number
  tokenPrice: number
  tokenLimit: number
  paymentProviderProductId?: string
  paymentProviderPriceId?: string
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export type ISubscriptionWithPlan = Omit<ISubscription, 'subscriptionPlan'> & {
  subscriptionPlan: Partial<ISubscriptionPlan>
}

export enum SubscriptionPlanType {
  Free = 'free',
  Pro = 'pro',
  Team = 'team',
}
